// src/contexts/Context/helpers/buildOptions.js

export const buildEmissionDetailOptions = (data = []) => {
  if (!Array.isArray(data)) return {};
  const types = Array.from(new Set(data.map((option) => option.type))).sort();

  const options = {};
  types.forEach((type) => {
    if (type) options[type] = {};
  });

  data.forEach((item) => {
    const type = item.type;
    const category = item.category || "";
    const sub_category = item.sub_category || "";
    const description = item.description || "";

    if (!type) return;
    if (!options[type]) options[type] = {};
    if (!options[type][category]) options[type][category] = {};
    if (!options[type][category][sub_category]) options[type][category][sub_category] = {};
    if (!options[type][category][sub_category][description]) options[type][category][sub_category][description] = [];
    options[type][category][sub_category][description].push(item);
  });

  return options;
};

export const buildEnvFactorOptions = (data = []) => {
  if (!Array.isArray(data)) return {};
  const options = {};

  data.forEach((item) => {
    const type = item.type;
    const category = item.category || "";
    const sub_category = item.sub_category || "";
    const description = item.description || "";

    if (!type) return;
    if (!options[type]) options[type] = {};
    if (!options[type][category]) options[type][category] = {};
    if (!options[type][category][sub_category]) options[type][category][sub_category] = {};
    if (!options[type][category][sub_category][description]) options[type][category][sub_category][description] = [];
    options[type][category][sub_category][description].push(item);
  });

  return options;
};

export const findEmissionOptionMatches = (emissionDetailOptions, type, category, sub_category, description) => {
  if (!description || !emissionDetailOptions || typeof emissionDetailOptions !== "object") return [];

  const targetDesc = String(description).toLowerCase().trim();
  const targetType = type ? String(type).toLowerCase().trim() : "";
  const targetCat = category ? String(category).toLowerCase().trim() : "";
  const targetSubCat = sub_category ? String(sub_category).toLowerCase().trim() : "";

  // 1. Direct path lookup (exact)
  if (type && category) {
    const direct = emissionDetailOptions?.[type]?.[category]?.[sub_category || ""]?.[description];
    if (direct && direct.length > 0) return direct;
  }

  // 2. Case-insensitive & trimmed search across the hierarchy with ranked precision
  let exactMatch = null;
  let catMatch = null;
  let typeMatch = null;
  let descMatch = null;

  for (const typeKey of Object.keys(emissionDetailOptions)) {
    const isTypeMatch = targetType ? typeKey.toLowerCase().trim() === targetType : false;
    const typeObj = emissionDetailOptions[typeKey];
    if (!typeObj || typeof typeObj !== "object") continue;

    for (const catKey of Object.keys(typeObj)) {
      const isCatMatch = targetCat ? catKey.toLowerCase().trim() === targetCat : false;
      const catObj = typeObj[catKey];
      if (!catObj || typeof catObj !== "object") continue;

      for (const subCatKey of Object.keys(catObj)) {
        const isSubCatMatch = targetSubCat ? subCatKey.toLowerCase().trim() === targetSubCat : false;
        const subCatObj = catObj[subCatKey];
        if (!subCatObj || typeof subCatObj !== "object") continue;

        for (const descKey of Object.keys(subCatObj)) {
          const normDescKey = descKey.toLowerCase().trim();
          if (normDescKey === targetDesc || normDescKey.includes(targetDesc) || targetDesc.includes(normDescKey)) {
            const list = subCatObj[descKey];
            if (list && list.length > 0) {
              if (isTypeMatch && isCatMatch && (isSubCatMatch || !targetSubCat)) {
                return list; // Best high-confidence match
              }
              if (isTypeMatch && isCatMatch && !exactMatch) {
                exactMatch = list;
              } else if (isCatMatch && !catMatch) {
                catMatch = list;
              } else if (isTypeMatch && !typeMatch) {
                typeMatch = list;
              } else if (!descMatch) {
                descMatch = list;
              }
            }
          }
        }
      }
    }
  }

  return exactMatch || catMatch || typeMatch || descMatch || [];
};

